import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import Button from 'material-ui/Button';
import { FormControlLabel } from 'material-ui/Form';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { CircularProgress } from 'material-ui/Progress';
import { toastr } from 'react-redux-toastr'

import * as login from '../../actions/userdetails'
import * as clearToasters from '../../actions/toaster'
import * as regData from '../../../appConstants'


class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            setValue: false,
            login: {
                userId: '',
                pass: '',
                token: null
            }
        }
    }
    componentDidMount() {
        // if (this.props.loginUser && this.props.loginUser.data) {}
        // else {
        // console.log('token', localStorage.getItem('TOKEN'));
        this.state.token = localStorage.getItem('TOKEN');
        // console.log('Login this.state.token', this.state.token);
        if (this.state.token && this.state.token.length > 0)
            this.props.actions.postLogin(this.state.token);
        else if (this.props.loginUser && this.props.loginUser.data)
            this.props.actions.logout();
        // }
    }

    handleChange(field, e) {
        const login = Object.assign({}, this.state.login, { [field]: e.target.value });
        this.setState(Object.assign({}, this.state, { 'login': login }));
    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.props.actions.login(this.state.login)
        this.setState({ setValue: true })
    };
    render() {
        const { loginUser, toastermsg } = this.props
        // console.log('Login this.state', this.state);

        let result = null;
        //Show toaster message based on messageType
        if (toastermsg.message) {
            toastermsg.message = toastermsg.message.split('~')[0];
            if (toastermsg.messageType == 'Warning')
                toastr.warning(toastermsg.message)
            if (toastermsg.messageType == 'Success')
                toastr.success(toastermsg.message);
            if (toastermsg.messageType == 'Error')
                toastr.error(JSON.stringify(toastermsg.message))
            this.props.actions.clearToasters();
        }
        else if (loginUser.isLoading)
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        else
            result = null;
        // if (loginUser && !loginUser.Satatus && loginUser.error && this.state.setValue) {
        //     this.props.actions.errorToasters(loginUser.error);
        //     this.setState({ setValue: false })
        // }

        return (
            
            <div className="bg-gradient login-container d-flex justify-content-center align-items-center slideInUpTiny">                
                
                <div className="bb">
                <div className="login-content">
                    <div className="login-header text-center mb-4">
                        <a className="app-logo" href="#/" title="Jambo">
                            <img src="loginlogo.png" height="65px" alt="Alpha Meeting" title="Alpha Meeting" />
                        </a>
                    </div>
                    {result}
                    <div className="login-form">
                        <ValidatorForm autoComplete="off" onSubmit={this.handleSubmit.bind(this)}>
                            <fieldset>
                                <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                    name="userId" label="User Id"
                                    validators={['required', regData.regexUserName, regData.regexUserNameLength]}
                                    errorMessages={['This field is required', regData.messageAlphaNumeric, regData.messageLength]}
                                    value={this.state.login.userId} onChange={this.handleChange.bind(this, 'userId')} />
                                {/* <TextField id="requiredEmail" label="Email" fullWidth defaultValue="" margin="normal" className="mt-1"
                                    onChange={(e) => { this.saveStateValues({ userId: e.target.value }) }} /> */}
                                <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                    name="pass" label="Password" type="password"
                                    validators={['required']}
                                    errorMessages={['This field is required']}
                                    value={this.state.login.pass} onChange={this.handleChange.bind(this, 'pass')} />
                                {/* <TextField type="password" id="requiredPassword" label="Password" fullWidth defaultValue=""
                                    margin="normal" className="mt-1" onChange={(e) => { this.saveStateValues({ pass: e.target.value }) }} /> */}
                                {/* <div className="mt-1 mb-2 d-flex justify-content-between align-items-center">
                                    <FormControlLabel control={<Checkbox value="gilad" />} label="Remember me" />
                                    <div className="pt-3 text-center">
                                        <a className="text-primary" href="#/app/app-module/forgot-password-2"
                                            title="Reset Password">Forgot your password</a>
                                    </div>
                                </div> */}

                                <div className="pt-3 text-center">
                                    <Button type="submit" variant="raised"
                                        className="jr-btn bg-primary text-white">Sign In</Button>
                                </div>
                            </fieldset>
                        </ValidatorForm>
                    </div>
                </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    // console.log("Login mapStateToProps State ", state)
    // const { loginUser } = state
    // return { loginUser }
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, login, clearToasters), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./app/login/index.js